var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFiserv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_31333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3809 113C51.4908 112.289 47.9218 112.427 45.8688 109.607C45.5856 109.215 44.3862 106.723 44.3862 106.474V97.4226H51.8822V105.211C51.8822 107.3 58.1747 109.552 58.9118 103.481C60.2277 92.6862 49.5959 91.7978 45.8438 83.5291C44.1489 79.7989 44.1155 72.107 46.6683 68.7852C50.2622 64.1036 62.3516 64.4993 65.0293 70.0314C65.2833 70.5535 66.0413 72.827 66.0413 73.2185V80.5862H58.9617C58.8826 77.7234 59.6489 71.3703 55.7385 70.9914C51.6115 70.5914 51.6948 77.0624 52.486 79.7611C53.5272 83.306 62.26 88.3245 64.717 92.6567C67.6487 97.8225 67.4947 109.842 60.7358 112.065C59.6905 112.411 57.0211 112.971 56.0425 113.004H54.3767L54.3809 113Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0485 52.3489C31.0485 50.2522 31.0526 48.1598 31.0568 46.0632V46C28.8996 46 26.7175 45.9958 24.6144 46.4884C22.857 46.901 20.7623 47.7514 19.6046 49.2292C18.4469 50.7069 18.5177 52.7825 18.5219 54.5592C18.5385 58.4494 18.551 62.3395 18.5677 66.2255C17.0476 66.2507 15.5235 66.2718 14.0034 66.297C14.0034 68.2379 13.9993 70.1788 13.9951 72.1196C15.5151 72.1449 17.0352 72.166 18.5552 72.1912C18.5593 85.5079 18.5677 98.8245 18.5718 112.137C20.9247 112.137 23.2818 112.137 25.6347 112.137C25.6389 98.8203 25.6472 85.5079 25.6514 72.1912C27.4462 72.1702 29.2411 72.1407 31.036 72.1112C31.036 70.1493 30.9735 67.9306 30.9735 65.9729C28.1292 65.9181 28.6039 66.0781 27.3838 66.0023H25.5139V55.2328C25.5139 55.2328 25.3015 51.3974 31.0443 52.3447L31.0485 52.3489Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.003 104.159H137.674V112.158H146.003V104.159Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2786 91.5284H76.4538V103.527C76.4704 105.569 78.2861 106.841 80.1226 107.127C82.792 107.544 85.1449 105.666 85.1991 102.971C85.2366 101.123 85.1991 99.2708 85.1991 97.4225H92.2786V104.369C92.2786 107.851 87.7852 111.947 84.4745 112.478C76.0373 113.825 69.7907 110.941 68.9661 101.839C68.3623 95.1743 68.508 83.7607 68.9411 76.9866C69.2243 72.5617 70.4653 67.9011 75.117 66.3897C80.1518 64.7561 88.4848 65.194 91.1084 70.6166C91.325 71.0671 92.2828 73.8163 92.2828 74.0605V91.5326L92.2786 91.5284ZM85.1991 85.6342V73.6353C85.1991 71.7913 82.1299 70.3346 80.4183 70.4482C78.7067 70.5619 76.4538 72.347 76.4538 74.0563V85.6342H85.1991Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.596 66.2675L125.385 103.742L130.591 66.2675H138.087L130.77 112.175L119.759 112.162L112.684 66.2675H120.596Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.603 65.4255V73.4248C107.642 73.2142 103.107 75.273 103.107 78.6874V112.158H96.0273V66.2675H102.69L102.899 70.4777C104.677 66.9454 106.68 65.7202 110.603 65.4255Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0566 66.2675H33.9771V112.158H41.0566V66.2675Z",
    fill: "#FF6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_31333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 67,
    fill: "white",
    transform: "translate(14 46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiserv);
export default __webpack_public_path__ + "static/media/logoFiserv.21f041f6b9fa0eec7b055790efd76c3f.svg";
export { ForwardRef as ReactComponent };